const BASE = '/api';

function getToken() {
  return localStorage.getItem('vf_token');
}

async function request(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    const e = new Error(err.error || 'Request failed');
    e.status = res.status;
    e.body = err;          // 409 on create carries the vehicle already in the workflow
    throw e;
  }
  return res.json();
}

export const api = {
  // Auth
  signup: (data) => request('/auth/signup', { method: 'POST', body: data }),
  login:  (data) => request('/auth/login',  { method: 'POST', body: data }),
  me:     ()     => request('/auth/me'),

  // Users (Manager only)
  salespeople:      ()           => request(`/users/salespeople`),
  listUsers:        (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/users${qs ? '?' + qs : ''}`);
  },
  approveUser:      (id)            => request(`/users/${id}/approve`,  { method: 'PUT' }),
  rejectUser:       (id)            => request(`/users/${id}/reject`,   { method: 'PUT' }),
  changeUserRole:   (id, role)      => request(`/users/${id}/role`,     { method: 'PUT', body: { role } }),
  resetUserPassword:(id, password)  => request(`/users/${id}/password`, { method: 'PUT', body: { password } }),
  deleteUser:       (id)            => request(`/users/${id}`,          { method: 'DELETE' }),
  createUser:       (data)          => request(`/users`,                { method: 'POST', body: data }),
  notifyStatus:     ()              => request(`/notify/status`),
  notifyTest:       ()              => request(`/notify/test`,          { method: 'POST', body: {} }),
  updateUserContact:(id, data)      => request(`/users/${id}/contact`,  { method: 'PUT', body: data }),

  // Vehicles
  listVehicles: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/vehicles${qs ? '?' + qs : ''}`);
  },
  getVehicle:    (id)         => request(`/vehicles/${id}`),
  vehicleActivity: (id)       => request(`/vehicles/${id}/activity`),
  todayVehicles: ()           => request(`/vehicles/today`),
  lookupStock:   (stock)      => request(`/vehicles/lookup?stock=${encodeURIComponent(stock)}`),
  archived:      (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/vehicles/archived${qs ? '?' + qs : ''}`);
  },
  createVehicle: (data)       => request(`/vehicles`,        { method: 'POST', body: data }),
  updateVehicle: (id, data)   => request(`/vehicles/${id}`,  { method: 'PUT',  body: data }),
  handOver:      (id)         => request(`/vehicles/${id}/handover`,  { method: 'PUT' }),
  archive:       (id)         => request(`/vehicles/${id}/archive`,   { method: 'PUT' }),
  unarchive:     (id)         => request(`/vehicles/${id}/unarchive`, { method: 'PUT' }),
  deleteVehicle: (id)         => request(`/vehicles/${id}`,            { method: 'DELETE' }),

  // Checklists
  vehicleChecklists: (id)        => request(`/checklists/vehicle/${id}`),
  submitChecklist:   (id, data)  => request(`/checklists/vehicle/${id}`, { method: 'POST', body: data }),

  // Stats
  dashboardStats: () => request(`/stats/dashboard`),

  // Push notifications
  pushVapidKey:    ()          => request(`/push/vapid-key`),
  pushSubscribe:   (sub)       => request(`/push/subscribe`,   { method: 'POST', body: { subscription: sub } }),
  pushUnsubscribe: (endpoint)  => request(`/push/unsubscribe`, { method: 'POST', body: { endpoint } }),
  pushTest:        ()          => request(`/push/test`,        { method: 'POST' }),

  // Car models (managed by Manager, read by everyone)
  listCarModels:   ()                  => request(`/car-models`),
  addCarModel:     (data)              => request(`/car-models`,            { method: 'POST', body: data }),
  deleteCarModel:  (id)                => request(`/car-models/${id}`,      { method: 'DELETE' }),
};
